import { Box, FlexBox, Span } from "@vp/swan";
import React, { useContext } from "react";
import { PageStaticDataContext } from "../../../../contexts/PageStaticDataContextProvider";

import ShippingExclusion from "./ShippingExclusion";

export interface ProductBuilderPriceProps {
  isPricingReady: boolean;
  pricePresentationElement: JSX.Element | undefined;
}

export const ProductBuilderPrice = (props: ProductBuilderPriceProps) => {
  const { isPricingReady, pricePresentationElement } = props;
  const { removeShippingNotIncludedCallout } = useContext(PageStaticDataContext);

  const isRenderingClientSide = typeof window !== "undefined";

  return (
    <FlexBox className={`${isPricingReady ? "fade-in active" : "fade-in"}`}>
      <Box className={"price-block"} mr={"3"}>
        <Span fontSize={"small"}>
          {isRenderingClientSide && isPricingReady ? pricePresentationElement : <span>&nbsp;</span>}
        </Span>
      </Box>
      {isRenderingClientSide && isPricingReady && !removeShippingNotIncludedCallout && (
        <ShippingExclusion />
      )}
    </FlexBox>
  );
};
